/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Membership_Not_ActiveInputs */

const en_us2_group_membership_not_active = /** @type {(inputs: Group_Membership_Not_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person has not accepted the invitation yet.`)
};

const pt_br2_group_membership_not_active = /** @type {(inputs: Group_Membership_Not_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa pessoa ainda não aceitou o convite.`)
};

const pt_pt2_group_membership_not_active = /** @type {(inputs: Group_Membership_Not_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa pessoa ainda não aceitou o convite.`)
};

/** @type {(inputs: Group_Membership_Not_ActiveInputs) => LocalizedString} */
const es_419_group_membership_not_active = en_us2_group_membership_not_active;

/** @type {(inputs: Group_Membership_Not_ActiveInputs) => LocalizedString} */
const fr_fr2_group_membership_not_active = en_us2_group_membership_not_active;

/** @type {(inputs: Group_Membership_Not_ActiveInputs) => LocalizedString} */
const de_de2_group_membership_not_active = en_us2_group_membership_not_active;

/** @type {(inputs: Group_Membership_Not_ActiveInputs) => LocalizedString} */
const it_it2_group_membership_not_active = en_us2_group_membership_not_active;

/**
* | output |
* | --- |
* | "This person has not accepted the invitation yet." |
*
* @param {Group_Membership_Not_ActiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_membership_not_active = /** @type {((inputs?: Group_Membership_Not_ActiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Membership_Not_ActiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_membership_not_active(inputs)
	if (locale === "es-419") return es_419_group_membership_not_active(inputs)
	if (locale === "pt-PT") return pt_pt2_group_membership_not_active(inputs)
	if (locale === "fr-FR") return fr_fr2_group_membership_not_active(inputs)
	if (locale === "de-DE") return de_de2_group_membership_not_active(inputs)
	if (locale === "it-IT") return it_it2_group_membership_not_active(inputs)
	return en_us2_group_membership_not_active(inputs)
});
export { group_membership_not_active as "group.membership_not_active" }